// Turbo Streams (tempo real via ActionCable) — SEM Turbo Drive.
//
// Só queremos os <turbo-stream> e <turbo-cable-stream-source> (broadcast do
// sino de notificações). O Turbo Drive intercepta cliques/forms e navega por
// AJAX — isso quebraria a inicialização do Alpine, o anti-FOUC (splash) e as
// máscaras, que dependem de DOMContentLoaded + reload completo. Por isso o Drive
// é desligado: a navegação continua sendo full page load, como hoje.
import "@hotwired/turbo-rails"

// window.Turbo é exposto pelo import acima.
if (window.Turbo) {
  window.Turbo.session.drive = false
}
